/** HL-10498 install funnel: promo seen, CTA clicked, then the HL-12077 OneLink carries the click into the install. */

import { MainTracker } from "./MainTracker";
import { APP_PLACEMENTS, AppPlacementId, getAppDeepLinkValue, getAppPid } from "../utils/appPlacements";

export const WEB_APP_PROMO_VIEWED = "web_app_promo_viewed";
export const WEB_APP_PROMO_CLICKED = "web_app_promo_clicked";

type Props = Record<string, string | number | null | undefined>;

export const getWebTrackingValue = (key: string): string | undefined => (window as any).eventsTracking?.getData?.(key);

/** Empty values are left out, never sent blank, as in the HL-12077 link. */
const withoutEmpty = (props: Props): Props =>
  Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined && value !== null && value !== ""));

// No query string: it can hold tokens or an email.
const promoProps = (placementId: AppPlacementId, customerUuid: string | null | undefined, props: Props): Props => ({
  ...props,
  page_url: `${window.location.origin}${window.location.pathname}`,
  promo_type: APP_PLACEMENTS[placementId].surface,
  user_id: customerUuid,
});

export const trackWebAppPromoViewed = (placementId: AppPlacementId, customerUuid: string | null | undefined, props: Props) => {
  MainTracker.track("custom", WEB_APP_PROMO_VIEWED, withoutEmpty(promoProps(placementId, customerUuid, props)));
};

export const trackWebAppPromoClicked = (
  placementId: AppPlacementId,
  customerUuid: string | null | undefined,
  ctaText: string,
  props: Props
) => {
  MainTracker.track(
    "custom",
    WEB_APP_PROMO_CLICKED,
    withoutEmpty({
      ...promoProps(placementId, customerUuid, props),
      cta_text: ctaText,
      pid: getAppPid(placementId),
      deep_link_value: getAppDeepLinkValue(placementId),
      // The browser id HL-12077 puts in deep_link_sub2.
      browser_id: getWebTrackingValue("uid"),
    })
  );
};
